/**
* @ngdoc service
* @name Notifications ui
*
* @description
* Used to store notifications ui data
*/

(function () {
  'use strict';

  app.service('notificationsUiService', function () {
    var _this = this;
    this.state = {
      loading: false,
      areNotificationsVisible: false
    };

    this.actions = {
      setLoading: function (value) {
        _this.state.loading = value;
      },
      toggleNotificationsVisibility: function () {
        _this.state.areNotificationsVisible = !_this.state.areNotificationsVisible;
      },
      hideNotifications: function () {
        _this.state.areNotificationsVisible = false;
      }
    };
  });
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/notifications/uiService.js